const parseURI = (str = '') => {
  const keys = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
  ]

  const parser = /^(?:(?![^:@]+:[^:@/]*@)([^:/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#/]*\.[^?#/.]+(?:[?#]|$)))*\/?)?([^?#/]*))(?:\?([^#]*))?(?:#(.*))?)/
  const matches = parser.exec(str)
  const uri = {}
  let i = 14

  while (i--) uri[keys[i]] = matches[i] || ''

  uri.queryKey = {}
  uri[keys[12]].replace(/(?:^|&)([^&=]*)=?([^&]*)/g, ($0, $1, $2) => {
    if ($1) uri.queryKey[$1] = $2
  })

  return uri
}

const getProductUrl = (product = "", isPartnerUser = false) => {

   // Get current URL from window object
   const currentUrl = window.location.href;

   // Regular expression to extract subdomain and domain
   const subdomainRegex = /\/\/([^/]+)\//;

   // Extract the subdomain and domain
   const match = currentUrl.match(subdomainRegex);
   const subdomain = match ? match[1] : null;

   // Split the domain into second-level domain and top-level domain
   const domainParts = subdomain ? subdomain.split('.') : [];
   const secondLevelDomain = domainParts.length >= 2 ? domainParts[0] : null;
   const topLevelDomain = domainParts.length >= 2 ? domainParts.slice(1).join('.') : null;

   let url = `https://${secondLevelDomain}.${topLevelDomain}`; 

   if(product){
    url = `https://${secondLevelDomain}.${product}.${topLevelDomain}`; 
   }

   if(isPartnerUser && product === "inbound"){
    url = `https://${secondLevelDomain}.${product}.${topLevelDomain}/partners/dashboard`; 
   }

   return url; 

}


const makeHyperlinksReadonly = (htmlContent, hasPremiumAccess) => {

  if (hasPremiumAccess) {
    return htmlContent; // Return original HTML if user has premium access
  }

  // Create a temporary DOM element to parse the HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;

  // Find all anchor tags and replace them with span tags
  const links = tempDiv.querySelectorAll('a');
  links.forEach(link => {
    // Create a new span element
    const span = document.createElement('span');
    
    // Copy the inner HTML content (preserves all nested elements and formatting)
    span.innerHTML = link.innerHTML;
    
    // Copy all attributes except href
    Array.from(link.attributes).forEach(attr => {
      if (attr.name !== 'href') {
        span.setAttribute(attr.name, attr.value);
      }
    });
    
    // Add styling to make it look like disabled text
    span.style.cursor = 'default';
    span.style.pointerEvents = 'none';
    
    // Replace the anchor tag with the span tag
    link.parentNode.replaceChild(span, link);
  });

  // Find and remove all image tags
  const images = tempDiv.querySelectorAll('img');
  images.forEach(img => {
    img.remove();
  });

  return tempDiv.innerHTML;

}


export { parseURI, getProductUrl, makeHyperlinksReadonly }

